import { MfNode } from "../node/MfNode";
import { findDataNode } from "./findDataNode";

export type ExprRes = {
  node: MfNode;
  suffix?: string;
};

const find = (expr: string, ownerNode: MfNode): ExprRes | undefined => {
  const pos = expr.indexOf(":");
  const path = pos < 0 ? expr : expr.slice(0, pos);
  const suffix = pos < 0 ? undefined : expr.slice(pos + 1);
  if (!path) {
    return suffix ? { node: ownerNode, suffix } : undefined;
  }
  const node = findDataNode(ownerNode, path.split("."));
  return node && { node, suffix };
};

/**
 * Поиск узла с данными по строковому выражению
 * @param expr abc.abc = абс. путь, .abc - относительно srcNode, "@abc" - относительно родителя
 * @param srcNode
 * @param root
 */
export const findByExpr = (
  expr: string,
  srcNode: MfNode,
  root: MfNode,
): ExprRes | undefined => {
  if (/^[a-z]/i.test(expr)) {
    return find(expr, root);
  }
  if (expr[0] === ".") {
    return find(expr.slice(1), srcNode);
  }
  if (expr[0] === "@") {
    const owner = findDataNode(root, srcNode.dataPath.slice(0, -1));
    if (owner) {
      let newExpr = expr.slice(1);
      if (newExpr[0] !== "@") newExpr = `.${newExpr}`;
      return findByExpr(newExpr, owner, root);
    }
  }
  return undefined;
};
